import script from "./ActivityPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityPage.vue?vue&type=script&setup=true&lang=js"

import "./ActivityPage.vue?vue&type=style&index=0&id=c6e6b7da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6e6b7da"]])

export default __exports__